export const STORAGE_COACH_KEY = '@fitify/coach-list'
export const LOGGED_IN_STORAGE_COACH_KEY = '@fitify/logged-in-coach-list'
